import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2db32cac")

_pushScopeId("data-v-2db32cac")
const _hoisted_1 = { class: "table-style-panel" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { style: {"flex":"2"} }, "行数：", -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { style: {"flex":"2"} }, "列数：", -1)
const _hoisted_6 = { class: "row theme-switch" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { style: {"flex":"2"} }, "启用主题表格：", -1)
const _hoisted_8 = {
  class: "switch-wrapper",
  style: {"flex":"3"}
}
const _hoisted_9 = { class: "row" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("标题行")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("汇总行")
const _hoisted_12 = { class: "row" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("第一列")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("最后一列")
const _hoisted_15 = { class: "row" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { style: {"flex":"2"} }, "主题颜色：", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_IconFontSize = _resolveComponent("IconFontSize")
  const _component_SelectOption = _resolveComponent("SelectOption")
  const _component_SelectOptGroup = _resolveComponent("SelectOptGroup")
  const _component_Select = _resolveComponent("Select")
  const _component_IconAddText = _resolveComponent("IconAddText")
  const _component_InputGroup = _resolveComponent("InputGroup")
  const _component_ColorPicker = _resolveComponent("ColorPicker")
  const _component_IconText = _resolveComponent("IconText")
  const _component_Button = _resolveComponent("Button")
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_Popover = _resolveComponent("Popover")
  const _component_IconFill = _resolveComponent("IconFill")
  const _component_ButtonGroup = _resolveComponent("ButtonGroup")
  const _component_IconTextBold = _resolveComponent("IconTextBold")
  const _component_CheckboxButton = _resolveComponent("CheckboxButton")
  const _component_IconTextItalic = _resolveComponent("IconTextItalic")
  const _component_IconTextUnderline = _resolveComponent("IconTextUnderline")
  const _component_IconStrikethrough = _resolveComponent("IconStrikethrough")
  const _component_CheckboxButtonGroup = _resolveComponent("CheckboxButtonGroup")
  const _component_IconAlignTextLeft = _resolveComponent("IconAlignTextLeft")
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_IconAlignTextCenter = _resolveComponent("IconAlignTextCenter")
  const _component_IconAlignTextRight = _resolveComponent("IconAlignTextRight")
  const _component_RadioGroup = _resolveComponent("RadioGroup")
  const _component_Divider = _resolveComponent("Divider")
  const _component_ElementOutline = _resolveComponent("ElementOutline")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_Switch = _resolveComponent("Switch")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_ColorButton = _resolveComponent("ColorButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InputGroup, {
      compact: "",
      class: "row"
    }, {
      default: _withId(() => [
        _createVNode(_component_Select, {
          style: {"flex":"3"},
          value: _ctx.textAttrs.fontname,
          onChange: _cache[1] || (_cache[1] = value => _ctx.updateTextAttrs({ fontname: value }))
        }, {
          suffixIcon: _withId(() => [
            _createVNode(_component_IconFontSize)
          ]),
          default: _withId(() => [
            _createVNode(_component_SelectOptGroup, { label: "系统字体" }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.availableFonts, (font) => {
                  return (_openBlock(), _createBlock(_component_SelectOption, {
                    key: font.value,
                    value: font.value
                  }, {
                    default: _withId(() => [
                      _createVNode("span", {
                        style: { fontFamily: font.value }
                      }, _toDisplayString(font.label), 5)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_component_SelectOptGroup, { label: "在线字体" }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.webFonts, (font) => {
                  return (_openBlock(), _createBlock(_component_SelectOption, {
                    key: font.value,
                    value: font.value
                  }, {
                    default: _withId(() => [
                      _createVNode("span", null, _toDisplayString(font.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode(_component_Select, {
          style: {"flex":"2"},
          value: _ctx.textAttrs.fontsize,
          onChange: _cache[2] || (_cache[2] = value => _ctx.updateTextAttrs({ fontsize: value }))
        }, {
          suffixIcon: _withId(() => [
            _createVNode(_component_IconAddText)
          ]),
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fontSizeOptions, (fontsize) => {
              return (_openBlock(), _createBlock(_component_SelectOption, {
                key: fontsize,
                value: fontsize
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(fontsize), 1)
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _: 1
    }),
    _createVNode(_component_ButtonGroup, { class: "row" }, {
      default: _withId(() => [
        _createVNode(_component_Popover, { trigger: "click" }, {
          content: _withId(() => [
            _createVNode(_component_ColorPicker, {
              modelValue: _ctx.textAttrs.color,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = value => _ctx.updateTextAttrs({ color: value }))
            }, null, 8, ["modelValue"])
          ]),
          default: _withId(() => [
            _createVNode(_component_Tooltip, {
              mouseLeaveDelay: 0,
              mouseEnterDelay: 0.5,
              title: "文字颜色"
            }, {
              default: _withId(() => [
                _createVNode(_component_Button, {
                  class: "text-color-btn",
                  style: {"flex":"1"}
                }, {
                  default: _withId(() => [
                    _createVNode(_component_IconText),
                    _createVNode("div", {
                      class: "text-color-block",
                      style: { backgroundColor: _ctx.textAttrs.color }
                    }, null, 4)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["mouseEnterDelay"])
          ]),
          _: 1
        }),
        _createVNode(_component_Popover, { trigger: "click" }, {
          content: _withId(() => [
            _createVNode(_component_ColorPicker, {
              modelValue: _ctx.textAttrs.backcolor,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = value => _ctx.updateTextAttrs({ backcolor: value }))
            }, null, 8, ["modelValue"])
          ]),
          default: _withId(() => [
            _createVNode(_component_Tooltip, {
              mouseLeaveDelay: 0,
              mouseEnterDelay: 0.5,
              title: "单元格填充"
            }, {
              default: _withId(() => [
                _createVNode(_component_Button, {
                  class: "text-color-btn",
                  style: {"flex":"1"}
                }, {
                  default: _withId(() => [
                    _createVNode(_component_IconFill),
                    _createVNode("div", {
                      class: "text-color-block",
                      style: { backgroundColor: _ctx.textAttrs.backcolor }
                    }, null, 4)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["mouseEnterDelay"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_CheckboxButtonGroup, { class: "row" }, {
      default: _withId(() => [
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "加粗"
        }, {
          default: _withId(() => [
            _createVNode(_component_CheckboxButton, {
              style: {"flex":"1"},
              checked: _ctx.textAttrs.bold,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateTextAttrs({ bold: !_ctx.textAttrs.bold })))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconTextBold)
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "斜体"
        }, {
          default: _withId(() => [
            _createVNode(_component_CheckboxButton, {
              style: {"flex":"1"},
              checked: _ctx.textAttrs.em,
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateTextAttrs({ em: !_ctx.textAttrs.em })))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconTextItalic)
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "下划线"
        }, {
          default: _withId(() => [
            _createVNode(_component_CheckboxButton, {
              style: {"flex":"1"},
              checked: _ctx.textAttrs.underline,
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateTextAttrs({ underline: !_ctx.textAttrs.underline })))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconTextUnderline)
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "删除线"
        }, {
          default: _withId(() => [
            _createVNode(_component_CheckboxButton, {
              style: {"flex":"1"},
              checked: _ctx.textAttrs.strikethrough,
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateTextAttrs({ strikethrough: !_ctx.textAttrs.strikethrough })))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconStrikethrough)
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"])
      ]),
      _: 1
    }),
    _createVNode(_component_RadioGroup, {
      class: "row",
      "button-style": "solid",
      value: _ctx.textAttrs.align,
      onChange: _cache[9] || (_cache[9] = e => _ctx.updateTextAttrs({ align: e.target.value }))
    }, {
      default: _withId(() => [
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "左对齐"
        }, {
          default: _withId(() => [
            _createVNode(_component_RadioButton, {
              value: "left",
              style: {"flex":"1"}
            }, {
              default: _withId(() => [
                _createVNode(_component_IconAlignTextLeft)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "居中"
        }, {
          default: _withId(() => [
            _createVNode(_component_RadioButton, {
              value: "center",
              style: {"flex":"1"}
            }, {
              default: _withId(() => [
                _createVNode(_component_IconAlignTextCenter)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "右对齐"
        }, {
          default: _withId(() => [
            _createVNode(_component_RadioButton, {
              value: "right",
              style: {"flex":"1"}
            }, {
              default: _withId(() => [
                _createVNode(_component_IconAlignTextRight)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"])
      ]),
      _: 1
    }, 8, ["value"]),
    _createVNode(_component_Divider),
    _createVNode(_component_ElementOutline, { fixed: true }),
    _createVNode(_component_Divider),
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_InputNumber, {
        min: _ctx.minRowCount,
        max: 20,
        value: _ctx.rowCount,
        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => (_ctx.rowCount = $event)),
        onPressEnter: _cache[11] || (_cache[11] = e => _ctx.setTableRow(e)),
        onBlur: _cache[12] || (_cache[12] = e => _ctx.setTableRow(e)),
        style: {"flex":"3"}
      }, null, 8, ["min", "value"])
    ]),
    _createVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_InputNumber, {
        min: _ctx.minColCount,
        max: 20,
        value: _ctx.colCount,
        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => (_ctx.colCount = $event)),
        onPressEnter: _cache[14] || (_cache[14] = e => _ctx.setTableCol(e)),
        onBlur: _cache[15] || (_cache[15] = e => _ctx.setTableCol(e)),
        style: {"flex":"3"}
      }, null, 8, ["min", "value"])
    ]),
    _createVNode(_component_Divider),
    _createVNode("div", _hoisted_6, [
      _hoisted_7,
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_Switch, {
          checked: _ctx.hasTheme,
          onChange: _cache[16] || (_cache[16] = checked => _ctx.toggleTheme(checked))
        }, null, 8, ["checked"])
      ])
    ]),
    (_ctx.hasTheme)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_Checkbox, {
              onChange: _cache[17] || (_cache[17] = e => _ctx.updateTheme({ rowHeader: e.target.checked })),
              checked: _ctx.theme.rowHeader,
              style: {"flex":"1"}
            }, {
              default: _withId(() => [
                _hoisted_10
              ]),
              _: 1
            }, 8, ["checked"]),
            _createVNode(_component_Checkbox, {
              onChange: _cache[18] || (_cache[18] = e => _ctx.updateTheme({ rowFooter: e.target.checked })),
              checked: _ctx.theme.rowFooter,
              style: {"flex":"1"}
            }, {
              default: _withId(() => [
                _hoisted_11
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode(_component_Checkbox, {
              onChange: _cache[19] || (_cache[19] = e => _ctx.updateTheme({ colHeader: e.target.checked })),
              checked: _ctx.theme.colHeader,
              style: {"flex":"1"}
            }, {
              default: _withId(() => [
                _hoisted_13
              ]),
              _: 1
            }, 8, ["checked"]),
            _createVNode(_component_Checkbox, {
              onChange: _cache[20] || (_cache[20] = e => _ctx.updateTheme({ colFooter: e.target.checked })),
              checked: _ctx.theme.colFooter,
              style: {"flex":"1"}
            }, {
              default: _withId(() => [
                _hoisted_14
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _createVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_Popover, { trigger: "click" }, {
              content: _withId(() => [
                _createVNode(_component_ColorPicker, {
                  modelValue: _ctx.theme.color,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = value => _ctx.updateTheme({ color: value }))
                }, null, 8, ["modelValue"])
              ]),
              default: _withId(() => [
                _createVNode(_component_ColorButton, {
                  color: _ctx.theme.color,
                  style: {"flex":"3"}
                }, null, 8, ["color"])
              ]),
              _: 1
            })
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
})